import axios from "axios";
import { localeQueryParam } from '../i18n'

const EMPTY_USER_ADDRESS = {
    voivodeship_id: '',
    country_id: 1,
    poviat: '',
    commune: '',
    locality: '',
    post_office: '',
    zip_code: '',
    house_number: '',
    apartment_number: '',
    street: '',
}

const EMPTY_USER_DATA = {
    name: '',
    lastname: '',
    phone: '',
    birthdate: {
        day: '',
        month: '',
        year: ''
    },
    gender: '',
    citizenship: '',
    pesel: '',
    noPesel: false,
    documentType: '',
    documentNumber: '',
    documentCountry: '',
    location: '',
}

const RESERVATION_ID_PARAM = 'reservationId'

const reservation = {

    // GETTERS AND CONSTS //

    getEmptyUserAddress:            () => {
        return JSON.parse(JSON.stringify(EMPTY_USER_ADDRESS));
    },

    getEmptyUserData:            () => {
        return JSON.parse(JSON.stringify(EMPTY_USER_DATA));
    },

    getPaymentReturnUrlWithParameters: (reservations, locale) => {
        const paymentReturnUrl = process.env.VUE_APP_PAYMENT_RETURN_URL
        const queryParametersConcatenator = paymentReturnUrl.indexOf('?') > -1 ? '&' : '?'
        const localeQuery = `&${localeQueryParam}=${locale}`
        return paymentReturnUrl + queryParametersConcatenator 
            + reservations.map(r => `${RESERVATION_ID_PARAM}=${r.reservation_id ?? r}`).join('&') 
            + localeQuery 
    },

    // GET //

    getDictionaries:                (locale = process.env.VUE_APP_I18N_LOCALE) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/personal_data/dictionary?language=${locale}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getLocalities:                  (voivodeship_id) => {
        return new Promise((resolve, reject) => {
            if(voivodeship_id) {
                axios.get(`/api/personal_data/dictionary/${voivodeship_id}`)    
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                })
            } else {
                reject('WRONG_INPUT');
            }
        })
    },
    getConsentsByScope:             (scope) => {
        return new Promise((resolve, reject) => {
            if(scope) {
                axios.get(`/api/consents?scope=${scope}`)
                .then(response => {
                    resolve(response.data.consents);
                })
                .catch(error => {
                    reject(error)
                })
            } else {
                reject('WRONG_INPUT');
            }
        })
    },
    getRecipientConsentsByScope:    (scope, file_id) => {
        return new Promise((resolve, reject) => {
            if(scope) {
                axios.get(`/api/consents/check?scope=${scope}${file_id ? ('&person_id=' + file_id) : ''}`)
                .then(response => {
                    resolve(response.data.consents);
                })
                .catch(error => {
                    reject(error)
                })
            } else {
                reject('WRONG_INPUT');
            }
        })
    },
    getLastUserData:                () => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/personal_data/last`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                switch(error.response.status) {
                    case 404: resolve(null); break;
                    default : reject(error);
                }
                reject(error);
            })
        })
    },
    getUserFilesFromMT:             () => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/person/file/mt`)
            .then(response => {
                resolve(response.data.files_data);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getUserAddressByFileId:         (file_id) => {
        return new Promise((resolve, reject) => {
            if(file_id) {
                axios.get(`/api/personal_data/address/${file_id}`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                })
            } else {
                reject('WRONG_INPUT');
            }
        })
    },
    getCart:                        () => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/cart/donor_data`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    updateCartItem:                 (cartItem, mzGrantFileId, locationOfTreatmentId, transportConsent) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/cart`, {
                items: {
                    [cartItem.donor_data.id]: {
                        "material_type": cartItem.material_type,
                        "material_location_name": cartItem.material_location_name,
                        "material_location_id": cartItem.material_location_id,
                        "quantity": cartItem.quantity,
                        "price": cartItem.price,
                        "price_id": cartItem.price_id,
                        "price_name": cartItem.price_name,
                        "age": cartItem.age,
                        "mz_grant_file_id": mzGrantFileId,
                        "want_mz_grant": cartItem.want_mz_grant,
                        ...(cartItem.material_type == 'mtSemen' && {"procedure": cartItem.donor_data.material.fitness_for_insemination}),
                        ...(locationOfTreatmentId && cartItem.material_location_id != locationOfTreatmentId && {"transport_consent": transportConsent})
                    }
                }
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getDonorDataByKeyAndType:       (product_key, material_type) => {
        return new Promise((resolve, reject) => {
            if(product_key && material_type) {
                axios.get(`/api/donor/${product_key}/${material_type}/data`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                reject('WRONG_INPUT')
            }
        })
    },
    getTransportPrices:             (locale = process.env.VUE_APP_I18N_LOCALE, pk_list) => {
        return new Promise((resolve, reject) => {
            const list = pk_list.map(pk => { return "&pk_list="+pk}).join("")
            axios.get(`/api/personal_data/locations?language=${locale}` + list)
            .then(response => {
                const locationsTransportList = response.data.sort(
                    (a,b) => a.transport.length < b.transport.length  ? -1 : 1);
                resolve(locationsTransportList);
            })
            .catch(error => {
                reject(error);
            })
        })
    },

    // POST //

    postNewConsents:                (consents, file_id) => {
        return new Promise((resolve, reject) => {
            if(consents) {
                if(consents.length > 0){
                    axios.post(`/api/consents`,
                        {
                            consents,
                            ...(!!file_id) && {file_id}
                        }
                    )
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    })
                } else {
                    resolve(true);
                }
            } else {
                reject('WRONG_INPUT');
            }
        });
    },
    postUserData:                   (userData) => {
        return new Promise((resolve, reject) => {
            if(userData) {
                axios.post('api/personal_data', userData)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                reject('WRONG_INPUT');
            }
        });
    },
    postUserAddress:                (userAddress, file_id) => {
        return new Promise((resolve, reject) => {
            if(userAddress && file_id) {
                axios.post(`/api/personal_data/address/${file_id}`, userAddress)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                reject('WRONG_INPUT');
            }
        });
    },
    postReservation:                (selected_items, personal_data_record_id, with_payment) => {
        return new Promise((resolve, reject) => {
            if(selected_items && Object.keys(selected_items).length && personal_data_record_id) {
                axios.post('/api/reservation',
                    {
                        selected_items,
                        with_payment,
                        personal_data_record_id
                    }
                )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                reject('WRONG_INPUT');
            }
        });
    },

    // PUT //

    updateConsents:                 (consents, file_id) => {
        return new Promise((resolve, reject) => {
            if(consents) {
                axios.put(`/api/consents`,
                    {
                        consents,
                        ...(!!file_id) && {file_id}
                    }
                )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                reject('WRONG_INPUT');
            }
        });
    },
    getPaymentUrl:                  (selected_reservations, return_url) => {
        return new Promise((resolve, reject) => {
            if(selected_reservations && selected_reservations.length > 0) {
                axios.put(`/api/reservation/payment`,
                    {
                        selected_reservations,
                        ...(!!return_url) && {return_url}
                    }
                )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                reject('WRONG_INPUT');
            }
        })
    },

    // DELETE //

    deleteItemByKey:                (product_key) => {
        return new Promise((resolve, reject) => {
            if(product_key) {
                axios.delete(`/api/cart?product_key=${product_key}`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                reject('WRONG_INPUT');
            }
        })
    }
}

export default reservation;